<div style="position: relative" class="{{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		style="display: none; visibility: hidden"
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-py-mini c-portlet-gap u-border-bottom custom-primary"
	>
		<div class="o-stack__cell">
			<h5 class="email-summary-header">{{ sectiontitle }}</h5>
		</div>
	</div>
	<div *ngIf="hasData && currentCreativeDetails" [ngClass]="{ 'min-height-to-load': showLoad }">
		<div class="creative-separation">
			<div *ngIf="isVideo" class="creative-video">
				<div class="creative-card-name">
					<h2 id="creativeName" class="creativeNameDropdown"></h2>
					<ng-select
						[searchable]="false"
						[clearable]="false"
						[title]="currentCreativeDetails.name"
						appendTo="#creativeName"
						[items]="creativeData"
						bindLabel="name"
						[(ngModel)]="currentCreativeDetails.name"
						(change)="changeCreativeData($event)"
					>
					</ng-select>
				</div>
				<div class="creative-bg">
					<div class="creativeControls">
						<app-custom-video-player
							[videoPlayerConfiguration]="videoPlayerConfig"
							[videoPlayerdata]="currentCreativeDetails"
						></app-custom-video-player>
					</div>
				</div>
			</div>
			<!-- Streaming Audio creatives -->
			<div *ngIf="isAudio" class="creative-video">
				<div class="creative-card-name">
					<h2 id="creativeName" class="creativeNameDropdown"></h2>
					<ng-select
						[searchable]="false"
						[clearable]="false"
						[title]="currentCreativeDetails.name"
						appendTo="#creativeName"
						[items]="creativeData"
						bindLabel="name"
						[(ngModel)]="currentCreativeDetails.name"
						(change)="changeCreativeData($event)"
					>
					</ng-select>
				</div>
				<div class="audio-creative-bg">
					<div class="audioCreativeControls">
						<fq-audio-player
							[configuration]="audioPlayerConfig"
							[data]="currentCreativeDetails"
							[colorPalette]="colorPalette"
						></fq-audio-player>
					</div>
				</div>
			</div>
			<!-- 					SEM Creatives          -->
			<div *ngIf="isSEM" class="creative-video">
				<div class="creative-card-name">
					<h2 id="creativeSEM" class="creativeNameDropdown"></h2>
					<ng-select
						[searchable]="false"
						[clearable]="false"
						[title]="currentCreativeDetails.creativeName"
						appendTo="#creativeSEM"
						[items]="creativesDropdown"
						bindLabel="creativeName"
						[(ngModel)]="currentCreativeDetails.creativeName"
						(change)="changeSemCreativeData($event)"
					>
					</ng-select>
				</div>
				<div class="creative-bg">
					<div class="creativeControls sem-creative-container">
						<div class="sem-creative-container-border">
							<div class="sem-creative-container-margin">
								<!--Ad Headline-->
								<div class="sem-creative-heading">{{ currentCreativeDetails.adHeadline }}</div>
								<!--Ad Url-->
								<div class="sem-creative-card-link-container">
									<cite class="sem-creative-card-link">
										<span class="sem-creative-card-text">AD </span>
										{{ currentCreativeDetails.url }}
									</cite>
								</div>
								<!--Description-->
								<div
									*ngIf="isTypeString(currentCreativeDetails?.description); else elseBlock"
									class="sem-creative-card-description sem-creative-card-roboto"
								>
									{{ currentCreativeDetails?.description }}
								</div>
								<ng-template #elseBlock>
									<div class="sem-creative-card-description sem-creative-card-roboto">
										<p *ngFor="let desc of currentCreativeDetails?.description">
											{{ desc }}
										</p>
									</div>
								</ng-template>
								<!--Callout Extensions-->
								<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
									<p>
										<span *ngFor="let callout of currentCreativeDetails?.calloutsExtn; let i = index"
											>{{ callout
											}}<span [ngClass]="{ last_callout_class: i == currentCreativeDetails?.calloutsExtn.length - 1 }">
												&middot;
											</span></span
										>
									</p>
								</div>
								<!--Structured Extensions-->
								<div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
									<div *ngFor="let snippet of currentCreativeDetails?.structuredSnippetExtn">
										<p>{{ snippet?.type }}: {{ snippet?.value }}</p>
									</div>
								</div>
								<!--Phone Call-->
								<span class="sem-creative-card-roboto"> {{ currentCreativeDetails.callExtension }}</span>
								<!--Address-->
								<div
									*ngIf="
										currentCreativeDetails &&
										currentCreativeDetails.location &&
										currentCreativeDetails.location.trim().split(',').length > 0
									"
								>
									<span
										*ngFor="
											let location of currentCreativeDetails.location.split(',');
											let last = last;
											let first = first
										"
										class="sem-creative-card-location"
									>
										<!--												<i class="fa fa-map-marker" aria-hidden="true" *ngIf="first" style="color: #575757;"></i>-->
										{{ location }}<span *ngIf="!last">,</span></span
									>
								</div>
								<!--Additional SiteLinks-->
								<div class="sem-creative-card-siteLinks-container">
									<div *ngFor="let siteLink of currentCreativeDetails.siteLinks" class="sem-creative-card-sitelinks">
										<h4>
											<a class="sem-creative-card-siteLinks-href" href="{{ siteLink.link }}" target="_blank">{{
												siteLink.heading
											}}</a>
										</h4>
										<span class="sem-creative-card-roboto">{{ siteLink.description }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 					Social Creatives          -->
			<div *ngIf="isSocial" class="social-creative">
				<div class="creative-card-name">
					<h2 id="creativeSEM" class="creativeNameDropdown"></h2>
					<ng-select
						[searchable]="false"
						[clearable]="false"
						[title]="currentCreativeDetails.creativeName"
						appendTo="#creativeSEM"
						[items]="creativesDropdown"
						bindLabel="creativeName"
						[(ngModel)]="currentCreativeDetails.creativeName"
						(change)="changeSemCreativeData($event)"
					>
					</ng-select>
				</div>
				<div class="creative-image">
					<div
						[innerHtml]="currentCreativeDetails?.iframeUrl | safeUrl : false"
						*ngIf="!currentCreativeDetails?.isIframeExpired"
					></div>
					<img
						[src]="currentCreativeDetails?.snapshotPath"
						alt="snapshot"
						*ngIf="
							currentCreativeDetails?.isIframeExpired &&
							currentCreativeDetails?.snapshotPath &&
							currentCreativeDetails?.snapshotPath !== 'null'
						"
					/>
					<div
						*ngIf="
							currentCreativeDetails?.isIframeExpired &&
							(!currentCreativeDetails?.snapshotPath || currentCreativeDetails?.snapshotPath === 'null')
						"
						class="card-long-img"
					>
						<img
							src="../../../../../../assets/images/no-creative-preview-r2.png"
							class="card-long-img"
							[ngStyle]="{
								background: 'url(../../../../../../assets/images/no-creative-preview-r2.png) no-repeat center center',
								'background-size': getCreativeSize(currentCreativeDetails?.thumbnail)
							}"
						/>
					</div>
					<div style="clear: both"></div>
				</div>
			</div>
			<div *ngIf="isEmail" class="social-creative">
				<div class="creative-card-name">
					<h2 id="creativeEmail" class="creativeNameDropdown"></h2>
					<ng-select
						[searchable]="false"
						[clearable]="false"
						[title]="currentCreativeDetails.name"
						appendTo="#creativeEmail"
						[items]="creativeData"
						bindLabel="name"
						[(ngModel)]="currentCreativeDetails.name"
						(change)="changeEmailCreativeData($event)"
					>
					</ng-select>
				</div>
				<div class="creative-image">
					<img
						[src]="currentCreativeDetails?.thumbnail"
						alt="thumbnail"
						*ngIf="currentCreativeDetails?.thumbnail && currentCreativeDetails?.thumbnail !== 'null'"
					/>
					<div
						*ngIf="!currentCreativeDetails?.thumbnail || currentCreativeDetails?.thumbnail === 'null'"
						class="card-long-img"
					>
						<img
							src="../../../../../../assets/images/no-creative-preview-r2.png"
							class="card-long-img"
							[ngStyle]="{
								background: 'url(../../../../../../assets/images/no-creative-preview-r2.png) no-repeat center center'
							}"
						/>
					</div>
					<div style="clear: both"></div>
				</div>
				<div class="email-creative-details">
					<div class="email-creative-name">{{ currentCreativeDetails.name }}</div>
					<div class="email-creative-brand">From/Brand: {{ currentCreativeDetails.from_line }}</div>
					<div class="email-creative-date">Deployment date: {{ currentCreativeDetails.date }}</div>
					<div
						*ngIf="currentCreativeDetails?.thumbnail"
						class="email-creative-preview"
						(click)="getPreviewScreenshot(currentCreativeDetails?.thumbnail && currentCreativeDetails?.thumbnail)"
					>
						Click to view fullscreen preview
					</div>
					<div
						*ngIf="!currentCreativeDetails?.thumbnail || currentCreativeDetails?.thumbnail === 'null'"
						class="email-creative-preview"
					>
						Click to view fullscreen preview
					</div>
				</div>
			</div>
			<div *ngIf="isDisplay || isGam || isGeofence" class="display-creative">
				<div class="creative-card-name">
					<h2 id="creativeSEM" class="creativeNameDropdown"></h2>
					<ng-select
						[searchable]="false"
						[clearable]="false"
						[title]="currentCreativeDetails.creativeName"
						appendTo="#creativeSEM"
						[items]="creativesDropdown"
						bindLabel="creativeName"
						[(ngModel)]="currentCreativeDetails.creativeName"
						(change)="changeSemCreativeData($event)"
					>
					</ng-select>
				</div>
				<fq-creative
					[creativeConfiguration]="currentCreativeDetails?.creativeConfiguration"
					[creativeImageData]="currentCreativeDetails?.creativeImageData"
					[enableCreativeButtons]="isDisplay || isGam ? true : false"
				></fq-creative>
			</div>
			<div class="social-creative-stats" *ngIf="(isSocial || isDisplay || isGam || isGeofence) && !isR10Config">
				<div class="creative-stat">
					<p class="creative-metric">{{ currentCreativeDetails?.impressions | number }}</p>
					<p class="creative-metric-name">impressions</p>
				</div>
				<div class="creative-stat">
					<p class="creative-metric"></p>
					<p class="creative-metric-name"></p>
				</div>
				<div class="creative-stat">
					<p class="creative-metric">{{ currentCreativeDetails?.clicks | number }}</p>
					<p class="creative-metric-name">clicks</p>
				</div>
				<div class="creative-stat">
					<p class="creative-metric">{{ currentCreativeDetails?.click_rate | number : '.2-2' }}%</p>
					<p class="creative-metric-name">click rate</p>
				</div>
				<div class="creative-stat" *ngIf="currentCreativeDetails?.isVideoCreative">
					<p class="creative-metric">{{ currentCreativeDetails?.completions | number }}</p>
					<p class="creative-metric-name">completions</p>
				</div>
				<div class="creative-stat" *ngIf="currentCreativeDetails?.isVideoCreative">
					<p class="creative-metric">{{ currentCreativeDetails?.completion_rate | number : '.2-2' }}%</p>
					<p class="creative-metric-name">completion rate</p>
				</div>
				<div class="creative-stat" *ngIf="isDisplay || isGam">
					<p class="creative-metric">{{ currentCreativeDetails?.adInteractions | number }}</p>
					<p class="creative-metric-name">ad interactions</p>
				</div>
				<div class="creative-stat" *ngIf="isDisplay || isGam">
					<p class="creative-metric">{{ currentCreativeDetails?.adInteractionRate | number : '.2-2' }}%</p>
					<p class="creative-metric-name">ad interaction rate</p>
				</div>
				<div class="creative-stat set-class-1" *ngIf="isSocial && !isR10Config">
					<p class="creative-metric" *ngIf="currentCreativeDetails.engagements">
						{{ currentCreativeDetails?.engagements | number }}
					</p>
					<p class="creative-metric" *ngIf="currentCreativeDetails && !currentCreativeDetails.engagements">- -</p>
					<p class="creative-metric-name">engagements</p>
				</div>
				<div class="creative-stat set-class-2" *ngIf="!isR10Config">
					<p class="creative-metric"></p>
					<p class="creative-metric-name"></p>
				</div>
				<div class="creative-stat subset-class-1" *ngIf="isSocial && !isR10Config">
					<p class="creative-metric" *ngIf="currentCreativeDetails.likes">
						{{ currentCreativeDetails?.likes | number }}
					</p>
					<p class="creative-metric" *ngIf="currentCreativeDetails && !currentCreativeDetails.likes">- -</p>
					<p class="creative-metric-name">likes</p>
				</div>
				<div class="creative-stat subset-class-2" *ngIf="isSocial && !isR10Config">
					<p class="creative-metric" *ngIf="currentCreativeDetails.shares">
						{{ currentCreativeDetails?.shares | number }}
					</p>
					<p class="creative-metric" *ngIf="currentCreativeDetails && !currentCreativeDetails.shares">- -</p>
					<p class="creative-metric-name">shares</p>
				</div>
				<div class="creative-stat subset-class-1" *ngIf="isSocial && !isR10Config">
					<p class="creative-metric" *ngIf="currentCreativeDetails.saves">
						{{ currentCreativeDetails?.saves | number }}
					</p>
					<p class="creative-metric" *ngIf="currentCreativeDetails && !currentCreativeDetails.saves">- -</p>
					<p class="creative-metric-name">saves</p>
				</div>
				<div class="creative-stat subset-class-2" *ngIf="isSocial && !isR10Config">
					<p class="creative-metric" *ngIf="currentCreativeDetails.comments">
						{{ currentCreativeDetails?.comments | number }}
					</p>
					<p class="creative-metric" *ngIf="currentCreativeDetails && !currentCreativeDetails.comments">- -</p>
					<p class="creative-metric-name">comments</p>
				</div>
				<div class="creative-stat subset-class-1" *ngIf="isSocial && !isR10Config">
					<p class="creative-metric" *ngIf="currentCreativeDetails.reactions">
						{{ currentCreativeDetails?.reactions | number }}
					</p>
					<p class="creative-metric" *ngIf="currentCreativeDetails && !currentCreativeDetails.reactions">- -</p>
					<p class="creative-metric-name">reactions</p>
				</div>
			</div>
			<div class="creative-stats-div" *ngIf="(isSocial || isDisplay || isGeofence) && isR10Config">
				<div *ngIf="isR10Config" class="creative-stats">
					<ng-container *ngFor="let legendItem of legend">
						<div
							class="creativeStats"
							*ngIf="
								!isSocial ||
								(isSocial &&
									(legendItem.displayName !== 'Completions' ||
										(legendItem.displayName === 'Completions' && (isVideo || currentCreativeDetails?.isVideoCreative))))
							"
						>
							<div class="stat-values secondary-color">
								<span
									class="stats secondary-color"
									*ngIf="
										(currentCreativeDetails[legendItem.value] === null ||
											currentCreativeDetails[legendItem.value] === undefined) &&
										legendItem.displayName
									"
								>
									--
								</span>
								<span
									*ngIf="
										currentCreativeDetails[legendItem.value] !== null &&
										currentCreativeDetails[legendItem.value] !== undefined &&
										!isSocial
									"
								>
									<span class="stats secondary-color" *ngIf="isR10Config">
										{{ currentCreativeDetails[legendItem.value] | number : '1.0-0'
										}}{{ isSEM && legendItem.displayName.includes('Top Impression') ? '%' : '' }}
									</span>
									<span class="stats secondary-color" *ngIf="!isR10Config">
										{{ currentCreativeDetails[legendItem.value] | number }}
									</span>
									<span class="stats secondary-color" *ngIf="currentCreativeDetails[legendItem.percentValue]">
										| {{ currentCreativeDetails[legendItem.percentValue] | number : '0.2-2' }}%
									</span>
								</span>
								<span
									*ngIf="
										currentCreativeDetails[legendItem.value] !== null &&
										currentCreativeDetails[legendItem.value] !== undefined &&
										isSocial
									"
								>
									<span *ngIf="legendItem.displayName !== 'Completions'">
										<span class="stats secondary-color">
											{{ currentCreativeDetails[legendItem.value] | number : '1.0-0' }}
										</span>
										<span class="stats secondary-color" *ngIf="currentCreativeDetails[legendItem.percentValue]">
											| {{ currentCreativeDetails[legendItem.percentValue] | number : '0.2-2' }}%
										</span>
									</span>
									<span
										*ngIf="
											legendItem.displayName === 'Completions' && (isVideo || currentCreativeDetails?.isVideoCreative)
										"
									>
										<span class="stats secondary-color">
											{{ currentCreativeDetails[legendItem.value] | number : '1.0-0' }}
										</span>
										<span class="stats secondary-color" *ngIf="currentCreativeDetails[legendItem.percentValue]">
											| {{ currentCreativeDetails[legendItem.percentValue] | number : '0.2-2' }}%
										</span>
									</span>
								</span>
							</div>
							<div class="stat-name" *ngIf="!isSocial">{{ legendItem.displayName }}</div>
							<div class="stat-name" *ngIf="isSocial && legendItem.displayName !== 'Completions'">
								{{ legendItem.displayName }}
							</div>
							<div
								class="stat-name"
								*ngIf="
									isSocial &&
									legendItem.displayName === 'Completions' &&
									(isVideo || currentCreativeDetails?.isVideoCreative)
								"
							>
								{{ legendItem.displayName }}
							</div>
						</div>
					</ng-container>
					<div class="engagements-sub-metrics creativeStats" *ngIf="isSocial">
						<div class="stat-values">
							<p class="creative-metric secondary-color" *ngIf="currentCreativeDetails.likes">
								{{ currentCreativeDetails?.likes | number }}
							</p>
							<p
								class="creative-metric secondary-color"
								*ngIf="currentCreativeDetails && !currentCreativeDetails.likes"
							>
								--
							</p>
							<p class="creative-metric-name">likes</p>
						</div>
						<div class="stat-values">
							<p class="creative-metric secondary-color" *ngIf="currentCreativeDetails.shares">
								{{ currentCreativeDetails?.shares | number }}
							</p>
							<p
								class="creative-metric secondary-color"
								*ngIf="currentCreativeDetails && !currentCreativeDetails.shares"
							>
								--
							</p>
							<p class="creative-metric-name">shares</p>
						</div>
						<div class="stat-values">
							<p class="creative-metric secondary-color" *ngIf="currentCreativeDetails.saves">
								{{ currentCreativeDetails?.saves | number }}
							</p>
							<p
								class="creative-metric secondary-color"
								*ngIf="currentCreativeDetails && !currentCreativeDetails.saves"
							>
								--
							</p>
							<p class="creative-metric-name">saves</p>
						</div>
						<div class="stat-values">
							<p class="creative-metric secondary-color" *ngIf="currentCreativeDetails.comments">
								{{ currentCreativeDetails?.comments | number }}
							</p>
							<p
								class="creative-metric secondary-color"
								*ngIf="currentCreativeDetails && !currentCreativeDetails.comments"
							>
								--
							</p>
							<p class="creative-metric-name">comments</p>
						</div>
						<div class="stat-values">
							<p class="creative-metric secondary-color" *ngIf="currentCreativeDetails.reactions">
								{{ currentCreativeDetails?.reactions | number }}
							</p>
							<p
								class="creative-metric secondary-color"
								*ngIf="currentCreativeDetails && !currentCreativeDetails.reactions"
							>
								--
							</p>
							<p class="creative-metric-name">reactions</p>
						</div>
					</div>
				</div>
			</div>
			<div class="creative-stats-div" *ngIf="!isSocial && !isDisplay && !isGeofence && legend.length">
				<div *ngIf="!isR10Config" class="creative-stats">
					<ul class="product-creative-stats">
						<li
							*ngFor="let legendItem of legend"
							appTooltip
							[attr.title]="legendItem?.tooltip"
							[options]="tooltipOptions"
						>
							<span
								class="stats secondary-color"
								*ngIf="
									(currentCreativeDetails[legendItem.value] === null ||
										currentCreativeDetails[legendItem.value] === undefined) &&
									legendItem.displayName
								"
							>
								--
							</span>
							<span
								*ngIf="
									currentCreativeDetails[legendItem.value] !== null &&
									currentCreativeDetails[legendItem.value] !== undefined
								"
							>
								<span class="stats secondary-color" *ngIf="!legendItem.isFloat">
									{{ currentCreativeDetails[legendItem.value] | number }}
								</span>
								<span class="stats secondary-color" *ngIf="legendItem.isFloat">
									{{ currentCreativeDetails[legendItem.value] | number : '0.2-2' }}%
								</span>
							</span>
							<span class="stats-label">{{ legendItem.displayName }}</span>
						</li>
					</ul>
				</div>
				<div *ngIf="isR10Config" class="creative-stats">
					<div *ngFor="let legendItem of legend" class="creativeStats">
						<div class="stat-values secondary-color">
							<span
								class="stats secondary-color"
								*ngIf="
									(currentCreativeDetails[legendItem.value] === null ||
										currentCreativeDetails[legendItem.value] === undefined) &&
									legendItem.displayName
								"
							>
								--
							</span>
							<span
								*ngIf="
									currentCreativeDetails[legendItem.value] !== null &&
									currentCreativeDetails[legendItem.value] !== undefined
								"
							>
								<span class="stats secondary-color" *ngIf="isR10Config">
									{{ currentCreativeDetails[legendItem.value] | number : '1.0-0'
									}}{{ isSEM && legendItem.displayName.includes('Top Impression') ? '%' : '' }}
								</span>
								<span class="stats secondary-color" *ngIf="!isR10Config">
									{{ currentCreativeDetails[legendItem.value] | number }}
								</span>
								<span class="stats secondary-color" *ngIf="currentCreativeDetails[legendItem.percentValue]">
									| {{ currentCreativeDetails[legendItem.percentValue] | number : '0.2-2' }}%
								</span>
							</span>
						</div>
						<div class="stat-name">{{ legendItem.displayName }}</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="isVideo || currentCreativeDetails?.isVideoCreative || isAudio" class="creativeProgressBar">
			<div>
				<div class="videoPercentage">
					<div class="progressBar">
						<div class="videoCompletionHeader">Started</div>
						<div class="videoCompletionPercent primary-color" *ngIf="currentCreativeDetails.percent_value_25 != null">
							<span>100%</span>
						</div>
					</div>
					<div class="progressBar">
						<div class="videoCompletionHeader">25% Completed</div>
						<div class="videoCompletionPercent primary-color" *ngIf="currentCreativeDetails.percent_value_25 != null">
							<span>{{ currentCreativeDetails.percent_rate_25 | number : '1.2-2' }}%</span>
						</div>
					</div>
					<div class="progressBar">
						<div class="videoCompletionHeader">50% Completed</div>
						<div class="videoCompletionPercent primary-color" *ngIf="currentCreativeDetails.percent_value_50 != null">
							<span>{{ currentCreativeDetails.percent_rate_50 | number : '1.2-2' }}%</span>
						</div>
					</div>
					<div class="progressBar">
						<div class="videoCompletionHeader">75% Completed</div>
						<div class="videoCompletionPercent primary-color" *ngIf="currentCreativeDetails.percent_value_75 != null">
							<span>{{ currentCreativeDetails.percent_rate_75 | number : '1.2-2' }}%</span>
						</div>
					</div>
					<div class="progressBar">
						<div class="videoCompletionHeader">Completed</div>
						<div class="videoCompletionPercent primary-color" *ngIf="currentCreativeDetails.percent_value_100 != null">
							<span>{{ currentCreativeDetails.percent_rate_100 | number : '1.2-2' }}%</span>
						</div>
					</div>
				</div>
				<app-custom-progress-bar
					[progressBarColorPalette]="colorPalette"
					[progressBarConfiguration]="progressBarConfig"
				></app-custom-progress-bar>
				<div class="videoPercentage">
					<div class="progressBar"></div>
					<div class="progressBar">
						<div class="secondary-color videoCompletionCount" *ngIf="currentCreativeDetails.percent_value_25 != null">
							<span>
								{{ currentCreativeDetails.percent_value_25 | number }}
								Views
							</span>
						</div>
					</div>
					<div class="progressBar">
						<div class="secondary-color videoCompletionCount" *ngIf="currentCreativeDetails.percent_value_50 != null">
							<span>
								{{ currentCreativeDetails.percent_value_50 | number }}
								Views
							</span>
						</div>
					</div>
					<div class="progressBar">
						<div class="secondary-color videoCompletionCount" *ngIf="currentCreativeDetails.percent_value_75 != null">
							<span>
								{{ currentCreativeDetails.percent_value_75 | number }}
								Views
							</span>
						</div>
					</div>
					<div class="progressBar">
						<div class="secondary-color videoCompletionCount" *ngIf="currentCreativeDetails.percent_value_100 != null">
							<span>
								{{ currentCreativeDetails.percent_value_100 | number }}
								Views
							</span>
						</div>
					</div>
				</div>
			</div>
			<div></div>
		</div>
	</div>
	<div *ngIf="!hasData" class="no-data-section">
		<div class="creative-separation">
			<div class="creative-video creative-no-data">
				{{ nodatamessage }}
			</div>
			<div class="creative-stats-div">
				<div class="creative-stats">
					<ul class="product-creative-stats">
						<li *ngFor="let legendItem of legend">
							<span class="stats secondary-color" *ngIf="!legendItem.isFloat && legendItem.displayName">--</span>
							<span class="stats secondary-color" *ngIf="legendItem.isFloat && legendItem.displayName">--</span>
							<span class="stats-label">{{ legendItem.displayName }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>

	<div class="timeline-chart" *ngIf="!isEmail && customchartconfiguration">
		<h2>Creative Performance</h2>
		<app-timeline-chart
			[filterSeries]="currentCreativeDetails?.filter"
			[showNoData]="!hasData"
			[data]="currentCreativeDetails?.chartdata"
			[customchartconfiguration]="customchartconfiguration"
			[uikitresponseconfig]="uikitresponseconfig"
			[nodatamessage]="nodatamessage"
			[seriesviewconfiguration]="seriesviewconfiguration"
			[requestwidgetdata]="false"
		></app-timeline-chart>
	</div>
	<div class="timeline-chart" *ngIf="isEmail && hasData">
		<app-datatable-r10
			(selected)="onPlaceSelected($event)"
			[toplinkdata]="currentCreativeDetails?.url_by_adgroup"
			[isemail]="true"
			datatableconfig="{{ datatableconfig }}"
			columnsconfig="{{ columnsconfig }}"
			[showtable]="true"
		>
		</app-datatable-r10>
	</div>
</div>
